import pages from './pages';
import common from './common.json';
import components from './components';
import breadcrumbs from './breadcrumbs.json';

export default { pages, common, components, breadcrumbs };
